module.exports = __webpack_public_path__ + "img/logo.ec48d495.png";